import KendoGanttDependencyDataSourceMixin from './KendoGanttDependencyDataSourceMixin'

export default {
    name: 'kendo-ganttdependencydatasource',
    mixins: [ KendoGanttDependencyDataSourceMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoGanttDependencyDataSource/index.js